import BookingCollectionSidebar from './BookingCollectionSidebar';

export default BookingCollectionSidebar;
